import signinOrganizationTemplateUrl from './signinorganization.tpl.html';

export default {
    templateUrl: signinOrganizationTemplateUrl,
    controller: [
        'SUBDOMAIN_ROOT',
        '$scope',
        '$http',
        'API_URL',
        '$window',
        'ssoRedirect',
        function (SUBDOMAIN_ROOT, $scope, $http, API_URL, $window, ssoRedirect) {
            $scope.SUBDOMAIN_ROOT = SUBDOMAIN_ROOT;

            $scope.state = '';
            $scope.domain = '';

            $scope.submit = function () {
                $scope.state = 'loading';
                let url = ssoRedirect.getAndClear() || '';
                // Redirect to '/home' when the cookie - SF_SSO_REDIRECT
                // is set to redirect to a different org id i.e. /home/:orgId
                const urlParams = url.split('/');
                if (urlParams.length === 3 && urlParams[1] === 'home') {
                    url = '/home';
                }

                const domain = ($scope.domain || '').trim().toLowerCase();
                if (!/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/.test(domain)) {
                    $scope.state = 'error';
                    return;
                }

                const orgHost = domain + '.' + SUBDOMAIN_ROOT;
                const orgUrl = 'https://' + orgHost;
                $http
                    .post(API_URL + '/v2/organization/_/hasDomain', orgHost, {
                        headers: { 'Content-Type': 'text/plain' },
                    })
                    .then(
                        () => {
                            $window.location.href = orgUrl + '/#' + url;
                        },
                        () => {
                            $scope.state = 'error';
                        }
                    );
            };
        },
    ],
};
